<div class="video-container">
  <qai-call-pathway-video
    [src]="src()"
    [autoplay]="autoplay()"
    [loop]="loop()"
    [startTime]="startTime()"
    [preventForwardSeek]="firstAttempt()"
    (videoPlay)="handleVideoPlay()"
    (videoPause)="handleVideoPause()"
    (videoEnded)="handleVideoEnded()"
    (videoTimeUpdate)="handleVideoTimeUpdate($event)"
  />
  @if (agentSpeaking()) {
    <div class="video-interaction-block" (click)="handleBlockedClick()"></div>
  }
</div>
